import React, { ReactElement } from 'react';
import { TIconProps } from './Icons.types';

function CircleErrorIcon({
  height = 52,
  width = 52,
  iconColor = '#D0021B',
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 52"
      data-testid="CircleErrorIcon"
      {...restProps}>
      <path
        d="M26 0l.43.003C40.57.233 52 11.806 52 26c0 14.337-11.663 26-26 26S0 40.337 0 26 11.663 0 26 0zm0 1.486l-.405.003C12.265 1.706 1.486 12.62 1.486 26c0 13.516 10.998 24.514 24.514 24.514S50.514 39.516 50.514 26C50.514 12.483 39.517 1.486 26 1.486zM15.69 15c.191 0 .363.078.488.204l9.781 9.85 9.783-9.849a.69.69 0 011.178.491.696.696 0 01-.202.492l-9.71 9.772 9.702 9.775a.693.693 0 01-.487 1.186.683.683 0 01-.488-.204l-9.776-9.845-9.776 9.845a.68.68 0 01-.485.203.698.698 0 01-.49-1.188l9.702-9.768h.001l-9.709-9.778A.696.696 0 0115.69 15z"
        fill={iconColor}
        fillRule="nonzero"
      />
    </svg>
  );
}

export default CircleErrorIcon;
